import React, { useContext, useState } from 'react'
import loginIcon from '../assest/signin.png'
import { Link, useNavigate } from 'react-router-dom';
import { FaEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import summaryApi from '../common';
import { toast } from 'react-toastify';
import Context from '../context';
import { apiCall } from "../helpers/apiCall";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({
    email: "",
    password: "",
    role: ""
  })

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setData((preve) => {
      return {
        ...preve,
        [name]: value
      }
    })
  }

  const navigate = useNavigate()
  const { fetchUserDetails, fetchUserAddToCart } = useContext(Context)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      console.log('Making login request to:', summaryApi.signin.url);
      console.log('Login data:', { email: data.email, password: '[HIDDEN]' });

      const dataResponse = await fetch(summaryApi.signin.url, {
        method: summaryApi.signin.method,
        credentials: 'include', // This is correct
        headers: {
          "Content-Type": "application/json" // Fixed capitalization
        },
        body: JSON.stringify(data)
      })

      console.log('Login response status:', dataResponse.status);
      
      if (!dataResponse.ok) {
        throw new Error(`HTTP error! status: ${dataResponse.status}`);
      }

      const dataApi = await dataResponse.json()
      console.log('Login API response:', dataApi);

      const userRole = dataApi.data?.role
      const userStatus = dataApi.data?.status

      if (dataApi.success) {
        toast.success(dataApi.message)
        
        // Fetch user details and cart immediately after login
        try {
          await fetchUserDetails()
          await fetchUserAddToCart()
          console.log('User details and cart fetched successfully');
        } catch (fetchError) {
          console.error('Error fetching user details:', fetchError);
          // Don't block navigation if this fails
        }

        // Small delay to ensure everything is set up
        setTimeout(() => {
          // Role-based navigation
          if (userRole === 'ADMIN') {
            console.log('Navigating to admin panel');
            navigate('/admin-pannel/pending-sellers');
          } else if (userRole === 'SELLER' && (userStatus === "ACCEPTED" || userStatus === "ACTIVE")) {
            console.log('Navigating to seller panel');
            navigate('/seller-pannel/all-products');
          } else if (userRole === 'SELLER' && (userStatus === "PENDING" || userStatus === "pending")) {
            console.log('Seller pending, staying on home page');
            navigate('/');
            toast.error("Your Seller status is under observation. You will be notified after approval")
          } else if (userRole === "GENERAL") {
            console.log('Navigating to home page');
            navigate('/');
          } else {
            console.log('Unknown role or status, staying on home page');
            navigate('/');
          }
        }, 500); // 500ms delay to ensure cookies are properly set
      }
      
      if (dataApi.error) {
        toast.error(dataApi.message)
      }
    } catch (error) {
      console.error('Login error:', error);
      
      // More specific error messages
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        toast.error('Network error. Please check your connection and try again.');
      } else if (error.message.includes('CORS')) {
        toast.error('Connection error. Please try again.');
      } else if (error.message.includes('401')) {
        toast.error('Invalid email or password.');
      } else if (error.message.includes('500')) {
        toast.error('Server error. Please try again later.');
      } else {
        toast.error(error.message || 'Login failed. Please try again.');
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section id="login" className="bg-gray-50 py-12">
      <div className="max-w-md mx-auto mt-8 bg-white p-8 rounded-lg shadow-md border border-blue-200">
        <div className="flex justify-center mb-4 cursor-pointer">
          <img
            src={loginIcon}
            alt="Login"
            className="h-16 w-16 hover:opacity-80 transition-opacity"
          />
        </div>

        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Login to Your Account</h2>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <div>
              <input
                type="email"
                placeholder="Enter email"
                name='email'
                value={data.email}
                onChange={handleOnChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
            </div>

            <div className="flex items-center border border-gray-300 rounded-md">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                name="password"
                value={data.password}
                onChange={handleOnChange}
                className="w-full px-3 py-2 border-none focus:outline-none"
                required
                disabled={isLoading}
              />
              <div
                className="cursor-pointer px-3"
                onClick={() => !isLoading && setShowPassword((prev) => !prev)}
              >
                <span>{showPassword ? <FaRegEye /> : <FaEyeSlash />}</span>
              </div>
            </div>

            {/* Forgot Password Link aligned right */}
            <div style={{ textAlign: 'right', width: '100%' }}>
              <Link
                to="/forget-password"
                className="text-sm text-blue-500 hover:text-blue-700 font-medium"
              >
                Forgot Password?
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-2 px-4 rounded-md transition duration-200 cursor-pointer ${
              isLoading 
                ? 'bg-gray-400 text-gray-200 cursor-not-allowed' 
                : 'bg-blue-500 text-white hover:bg-blue-600'
            }`}
          >
            {isLoading ? 'Signing In...' : 'Login'}
          </button>

          <div className="text-center mt-4">
            <p className="text-sm text-gray-600">
              Don't have an account?{' '}
              <Link
                to="/signup"
                className="text-blue-500 hover:text-blue-700 font-medium cursor-pointer"
              >
                Sign up
              </Link>
            </p>
          </div>
        </form>
      </div>
    </section>
  )
}

export default Login